import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Newspaper as NewspaperIcon, SearchOffRounded } from '@mui/icons-material';

const ArticleListEmptyState = ({ hasActiveFilters, onClearFilters }) => (
  <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary', px: 3 }}>
    {hasActiveFilters ? (
      <>
        <SearchOffRounded sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
        <Typography variant="body1" sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}>
          Nenhum artigo encontrado com os filtros atuais.
        </Typography>
        <Typography variant="body2" sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>
          A combinação de filtros (período, fontes, tags, etc.) que você aplicou não retornou resultados. Experimente ajustar os filtros ou limpá-los.
        </Typography>

        <Button
          variant="text"
          onClick={onClearFilters}
          startIcon={<CloseIcon />}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'action.hover'
            }
          }}
        >
          Limpar todos os filtros
        </Button>
      </>
    ) : (
      <>
        <NewspaperIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
        <Typography variant="body1" sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}>
          Sua base de artigos está vazia.
        </Typography>
        <Typography variant="body2">
          Não há nenhum conteúdo cadastrado no momento.
        </Typography>
      </>
    )}
  </Box>
);

ArticleListEmptyState.propTypes = {
  hasActiveFilters: PropTypes.bool.isRequired,
  onClearFilters: PropTypes.func.isRequired
};

export default ArticleListEmptyState;
